import type { Formula } from "building-types/options/formula";
import type { MatchExpression } from "building-types/options/matchExpressionTypes";
import { evalFormula, type FormulaEvalContextInput } from "./formulaEval";
import { formulaInvert } from "./formulaUtils";

export function evalMatchExpression<T>(
  expression: MatchExpression<T>,
  env: (value: string, formula: Formula) => any,
  context?: FormulaEvalContextInput,
  contextualError?: (e: { type: any; context: string }, context: FormulaEvalContextInput) => any,
): { value: T; matchIndex: number | undefined } {
  for (let i = 0; i < expression.cases.length; i++) {
    const item = expression.cases[i];

    if (item) {
      if (item.condition === undefined) {
        return { value: item.value, matchIndex: i };
      } else if (item.condition) {
        const result = evalFormula(formulaInvert(item.condition), context, env, contextualError);

        if (result) {
          return { value: item.value, matchIndex: i };
        }
      }
    }
  }
  return { value: expression.defaultValue, matchIndex: undefined };
}
